module.exports = __webpack_public_path__ + "static/media/website-on-monitor@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ThankYou/img/website-on-monitor@3x.png
// module id = 581
// module chunks = 0